export interface IKeypadInfoView {
    initializeMainGameLayout(): void;

    initializeFreeSpinsLayout(): void;

    refreshBalance(balance: number): void;

    refreshFreeSpinsInfo(left: number, total: number): void;

    refreshTotalBetInfo(value: string): void;

    refreshLeftTicker(value: string): void;

    refreshRightTicker(value: string): void;
}
